export const MAX_FILE_SIZE = 10000000;
